import { render } from "./QuranAyatDetail.vue?vue&type=template&id=0498a2ce"
import script from "./QuranAyatDetail.vue?vue&type=script&lang=js"
export * from "./QuranAyatDetail.vue?vue&type=script&lang=js"
script.render = render

export default script